import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "subtitle-bg level-bg-dark p-2",
    style: _normalizeStyle(_ctx.getBarStyle(_ctx.config))
  }, _toDisplayString(_ctx.content), 5))
}